
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {RequestMonitoringRequest} from './RequestMonitoringRequest';
import {FieldModelRequestMonitoringRequest} from './RequestMonitoringRequest';

/**
 * RequestMonitoringRequestUpdateNotify struct
 */
class RequestMonitoringRequestUpdateNotify {
  /**
   * Initialize struct
   * @param {!RequestMonitoringRequest=} request
   * @constructor
   */
  constructor (request = new RequestMonitoringRequest()) {
    this.Request = request
  }

  /**
   * Copy struct (shallow copy)
   * @this {!RequestMonitoringRequestUpdateNotify}
   * @param {!RequestMonitoringRequestUpdateNotify} other Other struct
   * @returns {!RequestMonitoringRequestUpdateNotify} This struct
   */
  copy (other) {
    if (other.Request != null) {
      this.Request = RequestMonitoringRequest.fromObject(other.Request)
    } else {
      this.Request = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!RequestMonitoringRequestUpdateNotify}
   * @returns {!RequestMonitoringRequestUpdateNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new RequestMonitoringRequestUpdateNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new RequestMonitoringRequestUpdateNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!RequestMonitoringRequestUpdateNotify}
   * @param {!RequestMonitoringRequestUpdateNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof RequestMonitoringRequestUpdateNotify)) {
      throw new TypeError('Instance of RequestMonitoringRequestUpdateNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!RequestMonitoringRequestUpdateNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Request: ((this.Request != null) ? this.Request : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return RequestMonitoringRequestUpdateNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!RequestMonitoringRequestUpdateNotify} other Object value
   * @returns {!RequestMonitoringRequestUpdateNotify} Created struct
   */
  static fromObject (other) {
    return new RequestMonitoringRequestUpdateNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!RequestMonitoringRequestUpdateNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return RequestMonitoringRequestUpdateNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!RequestMonitoringRequestUpdateNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6436
  }
}

export { RequestMonitoringRequestUpdateNotify };

/**
 * Fast Binary Encoding RequestMonitoringRequestUpdateNotify field model
 */
class FieldModelRequestMonitoringRequestUpdateNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Request = new FieldModelRequestMonitoringRequest(buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Request.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Request.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelRequestMonitoringRequestUpdateNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6436
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Request.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Request.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Request.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!RequestMonitoringRequestUpdateNotify} fbeValue Default value, defaults is new RequestMonitoringRequestUpdateNotify()
   * @returns {!RequestMonitoringRequestUpdateNotify} RequestMonitoringRequestUpdateNotify value
   */
  get (fbeValue = new RequestMonitoringRequestUpdateNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!RequestMonitoringRequestUpdateNotify} fbeValue RequestMonitoringRequestUpdateNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Request.fbeSize) <= fbeStructSize) {
      fbeValue.Request = this.Request.get()
    } else {
      fbeValue.Request = new RequestMonitoringRequest()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Request.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {!RequestMonitoringRequestUpdateNotify} fbeValue RequestMonitoringRequestUpdateNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelRequestMonitoringRequestUpdateNotify}
   * @param {RequestMonitoringRequestUpdateNotify} fbeValue RequestMonitoringRequestUpdateNotify value
   */
  setFields (fbeValue) {
    this.Request.set(fbeValue.Request)
  }
}

export { FieldModelRequestMonitoringRequestUpdateNotify };

/**
 * Fast Binary Encoding RequestMonitoringRequestUpdateNotify model
 */
class RequestMonitoringRequestUpdateNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelRequestMonitoringRequestUpdateNotify(this.buffer, 4)
  }

  /**
   * Get the RequestMonitoringRequestUpdateNotify model
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @returns {!FieldModelRequestMonitoringRequestUpdateNotify} model RequestMonitoringRequestUpdateNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return RequestMonitoringRequestUpdateNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelRequestMonitoringRequestUpdateNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @param {!RequestMonitoringRequestUpdateNotify} value RequestMonitoringRequestUpdateNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @param {!RequestMonitoringRequestUpdateNotify} value RequestMonitoringRequestUpdateNotify value, defaults is new RequestMonitoringRequestUpdateNotify()
   * @return {!object} Deserialized RequestMonitoringRequestUpdateNotify value and its size
   */
  deserialize (value = new RequestMonitoringRequestUpdateNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new RequestMonitoringRequestUpdateNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new RequestMonitoringRequestUpdateNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!RequestMonitoringRequestUpdateNotifyModel}
   * @param {!number} prev Previous RequestMonitoringRequestUpdateNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { RequestMonitoringRequestUpdateNotifyModel };
